import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsTextTemplates from './SettingsTextTemplates';

function NoteTemplatesPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        title="Note Templates"
        subtitle="Reusable note and text templates"
        backTo="/reports-and-templates"
        backLabel="Reports & Templates"
        sticky
      />
      <div className="p-6">
        <SettingsTextTemplates />
      </div>
    </div>
  );
}

export default NoteTemplatesPage;
